import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaHistory, FaSyncAlt } from 'react-icons/fa';

export const OutdatedContent = () => {
  return (
    <ChakraV3.Stack maxW='md' gap={6} alignSelf='center' align='center' textAlign='center' mt={4}>
      <ChakraV3.Square size='16' rounded='2xl' bg='blue.50'>
        <ChakraV3.Icon color='blue.400' boxSize='10'>
          <FaHistory />
        </ChakraV3.Icon>
      </ChakraV3.Square>
      <ChakraV3.Text fontWeight='bold' fontSize='4xl'>
        Document updated
      </ChakraV3.Text>
      <ChakraV3.Text fontSize='xl' fontWeight='semibold' color='gray.600'>
        Someone restored a previous version of this document. Refresh to load the latest version.
      </ChakraV3.Text>
      <ChakraV3.Button onClick={() => window.location.reload()} w='full' variant='subtle' size='sm'>
        <FaSyncAlt />
        Refresh
      </ChakraV3.Button>
    </ChakraV3.Stack>
  );
};
